var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBadge',{attrs:{"rounded":_vm.rounded,"bg-class":"tw-bg-promote-turbo","text-class":"tw-text-white"}},[_c('fa',{staticClass:"tw-text-white tw-mr-2",attrs:{"icon":_vm.faStar}}),_vm._v("\n  "+_vm._s(_vm.$t('promoted::condition'))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }